export default {
  GET_CATEGORIES: ({ page = 1, rowsPerPage = 10 }) => `core/categories/?page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_SUB_CATEGORIES: 'core/sub-categories/',
  GET_CATEGORY_SUB_CATEGORIES: (id) => `core/sub-categories/?category_id=${id}`,
  CREATE_CATEGORY: 'customers/create/',
  UPDATE_CATEGORY: (id) => `customers/${id}/update/`,
  DELETE_CATEGORY: (id) => `customers/${id}/delete/`,
};
